<template>
  <!-- 驳回 -->
  <div>
    <Modal v-model="visible" title="驳回" :mask-closable="false" :footer-hide="true" width="500px" class="my-modal">
      <Form v-if="visible" ref="myForm" :model="formData" class="page-form">
        <FormItem label="驳回原因" prop="remark" class="full" :rules="$units.formRule.required('请输入驳回原因')">
          <Input v-model="formData.remark" type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入" />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save()">确定驳回</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {},
  data() {
    return {
      visible: false,
      formData: {}
    };
  },
  computed: {},
  methods: {
    save() {
      this.$refs.myForm.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.$http({
          url: '/buz/userCashWithdrawLog/okbReject',
          type: 'POST',
          data: this.formData
        }).then(res => {
          this.visible = false;
          this.$emit('reload');
          this.$notice.success('操作成功');
        });
      })
    },
    open(data) {
      this.formData = {
        ids: data.ids,
        remark: '',
      };
      this.visible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-left: 20px;
  }
  /deep/.ivu-tooltip-rel {
    .ivu-btn {
      margin-left: 10px;
    }
  }
}
</style>
